import {defineType} from 'sanity'

export {default as destinationCta} from './destination-cta'
export {default as shipCta} from './ship-cta'
export {default as linkCta} from './link-cta'

export const ctaButtons = defineType({
  name: 'ctaButtons',
  type: 'array',
  title: 'CTA Buttons',
  of: [{type: 'destinationCta'}, {type: 'shipCta'}, {type: 'linkCta'}],
  validation: (Rule) => Rule.max(1),
})
